export function getApiBaseUrl(): string | undefined {
    return import.meta?.env['VITE_API_BASE_URL'];
}

export function getWebSocketUrl(): string | undefined {
    return import.meta?.env['VITE_WEBSOCKET_URL'];
}

export function getSentryDsn(): string | undefined {
    if (import.meta?.env['VITE_SENTRY_DSN']) {
        return import.meta.env['VITE_SENTRY_DSN'];
    }

    return undefined;
}

export function getPostHogToken(): string | undefined {
    if (import.meta?.env['VITE_POST_HOG_TOKEN']) {
        return import.meta.env['VITE_POST_HOG_TOKEN'];
    }

    return undefined;
}

export function getSentryTraceSampleRate(): number | undefined {
    const rate = import.meta?.env['VITE_SENTRY_TRACES_SAMPLE_RATE'];

    return rate ? parseFloat(rate) : undefined;
}

export function getSentryReplaySessionSampleRate(): number | undefined {
    const rate = import.meta?.env['VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE'];

    return rate ? parseFloat(rate) : undefined;
}

export function getSentryReplayOnErrorSampleRate(): number | undefined {
    const rate = import.meta?.env['VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE'];

    return rate ? parseFloat(rate) : undefined;
}
